import { createSlice } from "@reduxjs/toolkit";
import { updateEmailTemplateAPI } from "../../services/updateEmailTemplate";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const updateEmailTemplateSlice = createSlice({
  name: "updateEmailTemplate",
  initialState: data,
  reducers: {
    updateEmailTemplateInfo(state) {
      state.isLoading = true;
    },
    updateEmailTemplateSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    updateEmailTemplateFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
      state.data = null;
    },
    updateEmailTemplateReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const updateEmailTemplateHandler = (data) => async (dispatch) => {
  try {
    dispatch(updateEmailTemplateAction.updateEmailTemplateInfo());
    const response = await updateEmailTemplateAPI(data);
    dispatch(updateEmailTemplateAction.updateEmailTemplateSuccess(response));
  } catch (e) {
    dispatch(updateEmailTemplateAction.updateEmailTemplateFailure(e));
  }
};
export default updateEmailTemplateSlice.reducer;
export const updateEmailTemplateAction = updateEmailTemplateSlice.actions;
